import React, { useEffect } from 'react';
import { DOFINANSOWANIE } from '../../data/dofinansowanie';
import './Dofinansowanie.css';

const Dofinansowanie = () => {
  const {
    znakiRP, naglowek, program, zadanie, opis, dataUmowy, dofinansowanie, wartoscCalkowita,
  } = DOFINANSOWANIE;

  useEffect(() => {
    const prevTitle = document.title;
    document.title = 'Dofinansowanie z FUS - Rafloor';
    return () => { document.title = prevTitle; };
  }, []);

  return (
    <div className="dofinansowanie-page">
      <div className="container">
        <article className="dof-board">
          <img
            src={znakiRP}
            alt="Barwy Rzeczypospolitej Polskiej i godło Rzeczypospolitej Polskiej"
            className="dof-board__znaki"
          />

          <h1 className="dof-board__title">{naglowek}</h1>
          <p className="dof-board__program">{program}</p>
          <p className="dof-board__zadanie">{zadanie}</p>

          <div className="dof-board__opis">
            {opis.map((akapit) => (
              <p key={akapit}>{akapit}</p>
            ))}
          </div>

          <div className="dof-board__footer">
            {(dofinansowanie || wartoscCalkowita) && (
              <dl className="dof-board__kwoty">
                {dofinansowanie && (
                  <div>
                    <dt>Dofinansowanie</dt>
                    <dd>{dofinansowanie}</dd>
                  </div>
                )}
                {wartoscCalkowita && (
                  <div>
                    <dt>Całkowita wartość</dt>
                    <dd>{wartoscCalkowita}</dd>
                  </div>
                )}
              </dl>
            )}
            <dl className="dof-board__data">
              <dt>Data podpisania umowy</dt>
              <dd>{dataUmowy}</dd>
            </dl>
          </div>
        </article>
      </div>
    </div>
  );
};

export default Dofinansowanie;
